export default "__VITE_ASSET__Cfz0wzxD__"